import _ from 'underscore'
import user from '../user'
import Backbone from 'backbone'
import ResultModel from '../models/result'
import Request from '../helpers/request'
import Alert from '../helpers/alert'
import messages from '../messages'
import config from '../config'

const ResultList = Backbone.Collection.extend({
    model: ResultModel,
    requestResults(dateFrom) {
        let api = '/api/me/result'

        if (this.parent.get('id') !== 0) {
            api = '/api/school/student/' + this.parent.get('id') + '/results'
        }

        if (this.parent.get('uid') !== null) {
            // logged in so ...
            // sync offline results and then get all results for the time period specified

            user.set('loading', true)

            return this.syncCheck()
                .then(() => Request({
                    url: api,
                    method: 'GET',
                    data: {
                        appId: config.get('id'),
                        after: dateFrom,
                        limit: 1000
                    },
                }))
                .then((response) => new Promise((resolve) => {
                    // add all the results from the server that are not already
                    // on the device
                    _.each(response.docs, (result) => {
                        if (this.unique(result)) {
                            this.add({
                                user: result.userId,
                                app_title: result.appId,
                                level: result.level,
                                start_timestamp: result.start_timestamp,
                                end_timestamp: result.end_timestamp,
                                score: result.score,
                                total: result.total,
                                fluency_score: result.fluency_score,
                                fluency_total: result.fluency_total,
                                reasoning_score: result.reasoning_score,
                                reasoning_total: result.reasoning_total,
                                problem_score: result.problem_score,
                                problem_total: result.problem_total,
                                star: result.star,
                                synced: true,
                            })
                        }
                    })

                    // then move on to syncing the results if the logged in user
                    user.set('loading', false)

                    // show the user that the results updated
                    Alert(messages.MSG_RESULTS_UPDATED)

                    resolve()
                }))
                .catch(Alert)
        }
    },
    unique(serverModel) {
        const localModel = this.findWhere({start_timestamp: serverModel.start_timestamp})
        return !(localModel && localModel.get('user'))
    },
    syncCheck() {
        if (this.parent.get('id') === 0) {
            // set the fail_silent to true so if there are zero results to sync
            // the promise will resolve and not reject, as the next step is to download the results
            return this.sync(true)
        } else {
            return new Promise((resolve) => resolve())
        }
    },
    sync(fail_silently) {
        // they must be logged in
        if (this.parent.get('uid') === null) {
            return new Promise((resolve, reject) => reject(messages.MSG_RESULTS_NOT_SAVED))
        }

        // if they are sync the results
        const resultsToSync = new ResultList

        // find the results that are not synced
        this.each((result) => {
            if (result.get('synced') === false) {
                const clone = result.toJSON()
                clone.synced = true
                resultsToSync.add(clone)
            }
        })

        if (resultsToSync.length > 0) {
            return Request({
                url: '/api/me/result',
                method: 'POST',
                data: {
                    appId: config.get('id'),
                    results: resultsToSync.toJSON(),
                },
            })
                .then(() => {
                    // everything is synced so remove all the results
                    // as keeping them in memory causes speed issues
                    this.reset()

                    // local save and then carry on
                    return this.parent.localSave()
                })
                .catch((error) => {
                    // remove all the results and just add the unsynced
                    // as keeping them in memory causes speed issues
                    this.reset()

                    resultsToSync.each((result) => {
                        // set synced to false as it failed to send
                        result.set('synced', false)
                        this.add(result)
                    })

                    this.parent.localSave()

                    if (error) {
                        Alert(error)
                    }
                })
        } else {
            return new Promise((resolve, reject) => {
                if (fail_silently) {
                    resolve()
                } else {
                    reject()
                }
            })
        }
    },
})

export default ResultList